<template>
  <v-container>
<!--    <v-alert type="warning" color="orange lighten-4" class="black&#45;&#45;text" :icon="false">-->
<!--      <div class="d-flex align-center">-->
<!--        <div>-->
<!--          <v-icon>mdi-info</v-icon>-->
<!--        </div>-->
<!--        <div class="text-body-2">-->
<!--          <strong>Note:</strong> Since this system is prepared as an example, the modules it contains may not function perfectly at 100%. Additionally, some features of the system have been deactivated for security reasons.-->
<!--        </div>-->
<!--      </div>-->
<!--    </v-alert>-->
    <Statistics />
    <v-row>
      <v-col cols="12" xl="8" lg="8">
        <new-orders />
        <div class="my-7"></div>
        <new-tickets />
      </v-col>

      <v-col cols="12" lg="4">
        <stats />
        <div class="my-7"></div>
        <new-members />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Statistics from "@/components/Dashboard/Statistics.vue";
import Stats from "@/components/Dashboard/Stats.vue";
import NewOrders from "@/components/Dashboard/NewOrders.vue";
import NewTickets from "@/components/Dashboard/NewTickets.vue";
import NewMembers from "@/components/Dashboard/NewMembers.vue";

export default {
  name: "Dashboard",
  components: {
    NewMembers,
    NewTickets,
    NewOrders,
    Statistics,
    Stats
  },
};
</script>